import { gql } from "graphql-request";

const SERVER_CREATE_DOCUMENT_FOLDER = gql`
  mutation SERVER_CreateDocumentFolder($input: DocumentFolderInput!) {
    createDocumentFolder(input: $input) {
      id
    }
  }
`;
export default SERVER_CREATE_DOCUMENT_FOLDER;